<template>
  <div class="listPage">
    <div class="search_wrap flex-rowl">
      <i class="iconfont icon-search"></i>
      <van-field
        v-model="keyword"
        class="search_input"
        placeholder="查找商品 →"
      />
    </div>
    <div class="screen_wrap">
      <div class="classify_wrap">
        <div class="default_wrap flex-between">
          <div class="left flex-rowl">
            <div class="item active">全部</div>
            <i class="iconfont icon-tubiaozhizuo-"></i>
            <div class="item" v-for="item in category" :key="item.id">
              {{ item.txt }}
            </div>
          </div>
          <div class="more">更多 <i class="iconfont icon-right"></i></div>
        </div>
        <div class="more_content">
          <div class="classify_list flex-rowl" v-if="classifyOne.length > 0">
            <div class="item" v-for="(item, index) in classifyOne" :key="index">
              {{ item }} <i class="iconfont icon-guanbi"></i>
            </div>
          </div>
          <div class="classify_list flex-rowl" v-if="classifyTwo.length > 0">
            <div class="item" v-for="(item, index) in classifyTwo" :key="index">
              {{ item }} <i class="iconfont icon-guanbi"></i>
            </div>
          </div>
          <div class="classify_list flex-rowl" v-if="classifyThree.length > 0">
            <div
              class="item"
              v-for="(item, index) in classifyThree"
              :key="index"
            >
              {{ item }} <i class="iconfont icon-guanbi"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="label_wrap flex-rowl">
        <div class="item" v-for="(item, index) in label" :key="index">
          {{ item }}
        </div>
      </div>
    </div>
    <div class="commodity_wrapper">
      <div class="commodity_list flex-between">
        <div class="commodity_list_column">
          <template v-for="(item, index) in list">
            <div :key="item.id" class="commodity_item" v-if="index % 2 == 0" @click="handleDetail">
              <div class="thumb">
                <van-image width="100%" fit="widthFix" :src="item.src" />
              </div>
              <div class="main">
                <div class="price flex-between">
                  <div class="spce-for-price"><span>¥</span> 600.00</div>
                  <div class="origin-price">600.00</div>
                </div>
                <div class="down">
                  <div class="tit">{{ item.tit }}</div>
                  <div class="subTie">
                    商品简介文字缩略显示，最多 显示两行...
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="commodity_list_column">
          <template v-for="(item, index) in list">
            <div :key="item.id" class="commodity_item" v-if="index % 2 == 1">
              <div class="thumb">
                <van-image width="100%" fit="widthFix" :src="item.src" />
              </div>
              <div class="main">
                <div class="price flex-between">
                  <div class="spce-for-price"><span>¥</span> 600.00</div>
                  <div class="origin-price">600.00</div>
                </div>
                <div class="down">
                  <div class="tit">{{ item.tit }}</div>
                  <div class="subTie">
                    商品简介文字缩略显示，最多 显示两行...
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 右侧工具 -->
    <my-tool></my-tool>
  </div>
</template>

<script>
import myTool from '../../../components/tool.vue'
export default {
  name: "cShopList",
  components: {
    myTool
  },
  data() {
    return {
      keyword: "",
      list: [
        {
          id: 1,
          src: "https://dev.vwingist.com/app_images/mall_smallapp/shop_thumb1.png",
          tit: "商品名称1",
          con: "21222",
          price: "",
        },
        {
          id: 2,
          src: "https://dev.vwingist.com/app_images/mall_smallapp/shop_thumb.png",
          tit: "商品名称2",
          con: "21222",
          price: "",
        },
        {
          id: 3,
          src: "https://dev.vwingist.com/app_images/mall_smallapp/shop_thumb2.png",
          tit: "商品名称3",
          con: "21222",
          price: "",
        },
        {
          id: 4,
          src: "https://dev.vwingist.com/app_images/mall_smallapp/shop_thumb1.png",
          tit: "商品名称4",
          con: "21222",
          price: "",
        },
        {
          id: 5,
          src: "https://dev.vwingist.com/app_images/mall_smallapp/shop_thumb.png",
          tit: "商品名称5",
          con: "21222",
          price: "",
        },
      ],
      label: [
        "全部",
        "原创设计",
        "百搭基础",
        "欧美",
        "职场休闲",
        "大牌极简高级感",
        "小女人（韩淑）",
        "潮流",
        "大尺码",
      ],
      category: [
        {
          txt: "新品",
          id: 1,
        },
        {
          txt: "爆款",
          id: 2,
        },
        {
          txt: "潮品",
          id: 3,
        },
        {
          txt: "女装",
          id: 4,
        },
        {
          txt: "男装",
          id: 5,
        },
      ],
      classifyOne: ["已选择的一级分类"],
      classifyTwo: ["已选择的二级分类","已选择的二级分类"],
      classifyThree: [],
    };
  },
  methods: {
    handleDetail() {
      this.$router.push('/comSalesIndex/cShopDetail')
    }
  }
};
</script>
<style lang="less" scoped>
.listPage {
  padding: 48px 0 540px;
  /deep/ .van-cell {
    padding: 0;
  }
  .search_wrap {
    width: 660px;
    height: 90px;
    margin: auto;
    border-bottom: 1px solid #dddddd;
    font-size: 24px;
    color: #c8c8c8;
    .iconfont {
      margin-right: 15px;
      font-size: 34px;
      color: #515151;
    }
  }
  .screen_wrap {
    width: 660px;
    margin: 0 auto 51px;
    box-sizing: border-box;
    .classify_wrap {
      font-size: 24px;
      color: #464646;
      padding: 25px 0 30px 17px;
      border-bottom: 1px solid #dddddd;
      .default_wrap {
        .item {
          margin-right: 23px;
          padding: 0 8px 6px;
          &:last-child {
            margin-right: 0;
          }
        }
        .active {
          border-bottom: 1px solid #d2d2d2;
        }
        .icon-tubiaozhizuo- {
          margin-right: 10px;
        }
      }
      .more_content {
        padding: 45px 0 0;
        font-size: 20px;
        color: #464646;
        box-sizing: border-box;
        .classify_list {
          flex-wrap: wrap;
          .item {
            padding: 0 10px 0 30px;
            border: 1px solid #d2d2d2;
            height: 40px;
            line-height: 40px;
            margin-bottom: 20px;
            margin-right: 10px;
            .iconfont {
              margin-left: 10px;
            }
          }
        }
      }
    }
    .label_wrap {
      padding: 30px 17px 40px;
      border-bottom: 1px solid #dddddd;
      font-size: 20px;
      color: #464646;
      flex-wrap: wrap;
      .item {
        min-width: 100px;
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        font-size: 20px;
        color: #464646;
        border: 1px solid #d2d2d2;
        text-align: center;
        box-sizing: border-box;
        margin: 0 10px 10px 0;
      }
    }
  }
  .commodity_wrapper {
    width: 630px;
    margin: auto;
    .commodity_list {
      align-items: flex-start;
      .commodity_list_column {
        width: 310px;
        .commodity_item {
          margin-bottom: 45px;
          .main {
            .price {
              font-size: 30px;
              color: #ff2800;
              margin: 10px 0 20px;
              span {
                font-size: 22px;
              }
              .origin-price {
                color: #c3c3c3;
                font-size: 28px;
                text-decoration: line-through;
              }
            }
            .down {
              font-size: 26px;
              color: #464646;
              .subTie {
                font-size: 20px;
                color: #464646;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                margin-top: 10px;
                line-height: 30px;
              }
            }
          }
        }
      }
    }
  }
}
</style>